export const GET_PLACES = 'GET_PLACES';
export const SET_CHOSEN_PLACE = 'SET_CHOSEN_PLACE';
export const PLACE_IMAGE_UPLOADED = 'PLACE_IMAGE_UPLOADED';